import React from 'react'
import { COMPUTER_VISION_PATH, CRYPTOGRAPHY_PATH } from '../../routes'
import Service from '../../components/Service'
import { softwareDevelopmentProjectsCardsInformation } from '../otherProjectsCardsInformation'

export default class SoftwareServices extends React.Component {
    texts() {
        return this.props.texts
    }

    solutionsTexts() {
        return this.texts()['solutions']
    }

    otherSolutions() {
        const texts = this.solutionsTexts()
        return [
            {
                title: texts['computerVisionSolutionTitle'],
                content: texts['computerVisionSolutionContent'],
                pillNames: texts['computerVisionSolutionPillNames'],
                buttonTitle: texts['solutionsCardButton'],
                path: COMPUTER_VISION_PATH,
            },
            {
                title: texts['cryptographySolutionTitle'],
                content: texts['cryptographySolutionContent'],
                pillNames: texts['cryptographySolutionPillNames'],
                buttonTitle: texts['solutionsCardButton'],
                path: CRYPTOGRAPHY_PATH,
            },
        ]
    }

    otherProjects() {
        return softwareDevelopmentProjectsCardsInformation(
            this.solutionsTexts()
        )
    }

    render() {
        return (
            <Service
                businessUnitDetailClassName="detailed-services-presentation-section"
                texts={this.texts()}
                otherSolutions={this.otherSolutions()}
                otherProjects={this.otherProjects()}
            />
        )
    }
}
